export default __webpack_public_path__ + "static/media/icon-send.dd32fc49.svg";